import React from "react";
import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import {
  NavLink,
  Switch,
  Route,
  useRouteMatch,
  Redirect,
} from "react-router-dom";
import Information from "./Information";
import Preferences from "./Preferences";
import AddOrganization from "./AddOrganization";
import Specialities from "./Specialities";

const useStyle = makeStyles((theme) => ({
  navWrapper: {
    backgroundColor: theme.palette.background.paper,
    position: "sticky",
    top: 80,
    zIndex: 2,
    boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
    // borderRadius: 12,
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(1),
  },
  gridContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(3),
  },
  navLink: {
    textDecoration: "none",
    color: theme.palette.text.secondary,
    padding: theme.spacing(1.2, 2),
    borderRadius: 8,
    fontWeight: 500,
    transition: "all 0.3s ease",
    fontSize: "0.95rem",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.dark,
    },
    "&.active": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontWeight: 600,
      boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
    },
  },
  typography: {
    color: "inherit", // Inherit color from parent
  },
}));

const Profile = () => {
  const classes = useStyle();
  let { path, url } = useRouteMatch();

  return (
    <>
      <Paper elevation={0} className={classes.navWrapper}>
        <Grid container className={classes.gridContainer}>
          <NavLink
            exact
            to={`${url}/information`}
            activeClassName="active"
            className={classes.navLink}
          >
            <Typography variant="body1" className={classes.typography}>Personal Information</Typography>
          </NavLink>
          <NavLink
            to={`${url}/preferences`}
            activeClassName="active"
            className={classes.navLink}
          >
            <Typography variant="body1" className={classes.typography}>Preferences</Typography>
          </NavLink>
          <NavLink
            to={`${url}/organization`}
            activeClassName="active"
            className={classes.navLink}
          >
            <Typography variant="body1" className={classes.typography}>Add Organization</Typography>
          </NavLink>
          <NavLink
            to={`${url}/speciality`}
            activeClassName="active"
            className={classes.navLink}
          >
            <Typography variant="body1" className={classes.typography}>Specialities</Typography>
          </NavLink>
        </Grid>
      </Paper>

      <Switch>
        <Route exact path={`${path}/information`} component={Information} />
        <Route exact path={`${path}/preferences`} component={Preferences} />
        <Route exact path={`${path}/organization`} component={AddOrganization} />
        <Route exact path={`${path}/speciality`} component={Specialities} />
        <Redirect from="/" to={`${path}/information`} />
      </Switch>
    </>
  );
};

export default Profile;
